<template>
	<v-select
		:modelValue="modelValue"
		chips
		:items='items'
		variant='underlined'
		color='primary'
		menu-icon='mdi-chevron-down'
		@update:modelValue="$emit('update:modelValue', $event)"
	>
		<template v-slot:prepend-item>
			<ao-btn
				density='compact'
				:class="[$style.add_btn, 'mx-2 mb-2']"
				color='primary'
				variant='tonal'
			>
				<ao-icon iconName='plus'/>
				Добавить
			</ao-btn>
		</template>
		<template v-slot:item='{ item }'>
			<div :class='$style.divider'/>
			<ao-checkboxes-collapse
				v-if='isSelectableGroup'
				class='px-4'
				:model-value='item.raw.checkboxSelected'
				:items='item.raw.checkboxItems'
				:model-mainItem='item.raw.mainItemSelected'
				:mainItem='item.raw.mainItem'
				:item-title='item.raw.itemTitle'
				:item-value='item.raw.itemValue'
				:returnObject='item.raw.returnObject'
				:isShowSelectAll='item.raw.isShowSelectAll'
				:isSearch='item.raw.isSearch'
				@update:modelMainItem="$emit('groupMainToggle', item.raw)"
				@update:modelValue="$emit('groupItemToggle', { key: $event, group: item.raw })"
			/>
			<div v-else
				class='px-4 py-3'>
				<span class='ao-p2-medium'>{{ item.raw.title }}</span>
				<template v-if='multiselect'>
					<ao-checkbox
						v-for='item in item.raw.items'
						:label='item.title'
						:model-value='modelValue.includes(item.title)'
						@update:modelValue="$emit('select', item)"
					/>
				</template>
				<template v-else>
					<div
						v-for='item in item.raw.items'
						class='ao-p2-regular px-1 py-1 cursor-pointer'
						@click="$emit('select', item)"
					>
						{{ item.title }}
					</div>
				</template>
			</div>
		</template>
		<template v-slot:chip='{ item, index }'>
			<v-chip
				v-if='index < 2'
				:class='$style.chip'
			>
				{{ item.title || item.value }}
			</v-chip>
			<div
				v-else-if='index < 3'
				:class='$style.counter'
			>
				+{{ modelValue.length - 2 }}
			</div>
		</template>
	</v-select>
</template>

<script>
export default {
	name: 'AoSelectGroup',
	props: {
		modelValue: {
			type: [String, Array],
			default: () => [],
		},
		items: Array,
		isSelectableGroup: Boolean,
		multiselect: Boolean,
	},
	emits: ['select', 'groupMainToggle', 'groupItemToggle', 'update:modelValue'],
}
</script>

<style module lang='scss'>
.add_btn {
	width: calc(100% - 16px);
}

.divider {
	height: 1px;
	max-height: 1px;
	width: calc(100% - 16px);
	margin-left: 8px;
	background: #E9EAEA;
}

.counter {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 4px;

	width: 20px;
	height: 20px;

	background: #EA5D31;
	border-radius: 20px;

	font-family: Inter, sans-serif;
	font-weight: 700;
	font-size: 10px;
	line-height: 12px;
	color: #FFFFFF;
}

.chip {
	height: 20px !important;
}
</style>
